module.exports = __webpack_public_path__ + "static/img/mystudy.dd41b434.png";